import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import {
  getMessagesCharId,
  refreshMessagesUnreadCount,
  refetchConversationsList,
  scheduleConversationsSync,
  useUnreadMessagesCount,
} from '@/hooks/useMessages';
import {
  processMessagesWsEvent,
  subscribeMessagesWs,
} from '@/hooks/useMessagesWebSocket';

/**
 * Mantiene el badge de mensajes y la lista de conversaciones sincronizados
 * en todas las rutas (no solo en /messages, donde no hay PlayerSidebar).
 */
export function MessagesRealtimeSync() {
  const queryClient = useQueryClient();
  const location = useLocation();
  const charId = getMessagesCharId();

  useUnreadMessagesCount(charId);

  useEffect(() => {
    if (charId <= 0) return;

    return subscribeMessagesWs((event) => {
      processMessagesWsEvent(queryClient, charId, event);
    });
  }, [charId, queryClient]);

  useEffect(() => {
    if (charId <= 0) return;
    void refreshMessagesUnreadCount(queryClient, charId);
    if (location.pathname === '/messages') {
      void refetchConversationsList(queryClient, charId);
    }
  }, [location.pathname, charId, queryClient]);

  useEffect(() => {
    if (charId <= 0) return;
    void refreshMessagesUnreadCount(queryClient, charId);
    scheduleConversationsSync(queryClient, charId, 0);
  }, [charId, queryClient]);

  return null;
}
